import React from 'react';
import { Box } from '@mui/material';
import { FadeLoader } from 'react-spinners';

const LoadingOverlay = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(52, 52, 52, 0.2)',
        zIndex: 1301, // Ensure it's above other content like modals
        cursor: 'pointer',
      }}
    >
      <FadeLoader
        color={'#ffffff'}
        height={30}
        width={5}
        radius={20}
        margin={'20px'}
      />
    </Box>
  );
};

export default LoadingOverlay;